module.exports = __webpack_public_path__ + "img/01.b3f545a2.png";